import { FC, useMemo } from 'react';
import Menu, { MenuItemConfig } from '../menu';
import Icon from '../icon';

interface Props {
  onSort: () => void;
}

const TileGroupMenu: FC<Props> = ({ onSort }) => {
  const TriggerEl = <Icon name="menu-dots" size="small" />;

  const menuItems: MenuItemConfig[] = useMemo(
    () => [{ id: 'sort', label: 'Edit order', onClick: onSort, icon: 'sort-asc' }],
    [onSort]
  );

  return (
    <Menu
      trigger={TriggerEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      menuItems={menuItems}
      minWidth={100}
    ></Menu>
  );
};

export default TileGroupMenu;
